import React, {useEffect, useState} from "react";
import {Button, Checkbox, Col, Input, notification, Row, Select, Space, Table, Tag, Tooltip} from "antd";
import {CloseSquareOutlined, DeleteOutlined, UploadOutlined} from "@ant-design/icons";
import {getListeAssertionActive} from "../../../../../../../data/params/assertion";
import {getListeProgramme} from "../../../../../../../data/params/programme";
import TableTitle from "../../../../../../common/TableTitle";
import PageChildLabel from "../../../../../../common/PageLabel/PageChildLabel";
import {appTheme} from "../../../../../../../config/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCartPlus, faCloudUpload} from "@fortawesome/free-solid-svg-icons";
import FormLabel from "../../../../../../common/Form/FormLabel";
import {ModalTitle} from "../../../../../../modals/modals.components";
import {FormContainer} from "../../../../../../common/common.components";
import SearchRow from "../../../../../../common/SearchRow";
import ModalAlert from "../../../../../../modals/Modal";

const ModalProgrammes = ({
         handleVisibility,
         visible,
         selectData,
         setSelectData,
         chargement,
    }) => {
    const [programmes, setProgrammes] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [assertions, setAssertions] = useState([]);
    const [programmesTravail, setProgrammesTravail] = useState([]);
    const [loading, setLoading] = useState(false);

    const [paramsRecherche, setParamsRecherche] = useState({
        question: "",
        assertion: "",
    });

    useEffect(() => {
        fetchProgramme();
        fetchAssertion();
    }, []);

    const fetchAssertion = async () => {
        try {
            const res = await getListeAssertionActive();
            setAssertions(res.result);
        } catch (error) {
            console.error('Erreur lors de la récupération des rubriques', error);
        }
    };

    const fetchProgramme = async () => {
        try {
            const res = await getListeProgramme();
            if (res.result) {
                if(res.result){
                    const updateList = res.result.filter((item) => item.codeSommaire === "PARTIE_LIEE")
                    if(updateList){
                        setProgrammes(updateList);
                        setFilteredItems(updateList);
                    }
                }
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des événements risques', error);
        }
    };

    const toggleCheckbox = (id) => {
        const selectedList = [...programmesTravail];
        const valueId = parseInt(id);

        if (isNaN(valueId)) {
            return;
        }

        const add = programmes.find((item) => item.id === valueId);

        const isAlreadySelected = programmesTravail.some((element) => element.programme_id === add.id);

        if (!isAlreadySelected) {
            const newElement = {
                programme_id: add.id,
                ref: add.reference,
                libelle: add.libelle,
                reponse: '1',
                commentaire: '',
            };

            setProgrammesTravail([...selectedList, newElement]);
        }
        else {
            const selectedIndex = selectedList.findIndex((item) => item.programme_id === (add.id));

            const updatedList = selectedList.filter((_, i) => i !== selectedIndex);
            setProgrammesTravail(updatedList)
        }

    };

    const handleValidate = () => {
        if(programmesTravail.length > 0 ){
            setLoading(true);
            setTimeout(() => {
                const updateList = []
                programmesTravail.forEach((programme) => {

                    const newElement = {
                        ref: programme.ref,
                        libelle: programme.libelle,
                        reponse: '1',
                        commentaire: '',
                    };

                    updateList.push(newElement)
                })

                setSelectData([...selectData, ...updateList]);

                handleVisibility();
                notification.success({
                    description: "Question ajouté avec succès !",
                });

                setLoading(false);
            }, 1000)
        }
    }

    const columsProgrammes = [
        {
            title: () => <TableTitle>REF</TableTitle>,
            dataIndex: 'reference',
            width: 40,
            render: (_, record) => (
                <Tag>
                    <span className='fw-bolder' style={{fontSize: '13px'}}>
                        {record.reference}
                    </span>
                </Tag>
            ),
        },
        {
            title: () => <TableTitle>Libellé</TableTitle>,
            dataIndex: 'libelle',
            width: 250,
            render: (_, record, index) => (
                <span className='' key={index} style={{fontSize: '13px'}}>
                    {record.libelle}
                </span>
            ),
        },
        {
            title: () => <TableTitle>Assertions</TableTitle>,
            dataIndex: 'assertions',
            width: 50,
            render: (_, record) => (
                <Space>
                    {record.assertions?.map((assertion, index) => (
                        <Tag key={index}>
                            <span className='fw-bolder' >
                                {assertion}
                            </span>
                        </Tag>
                    ))}
                </Space>
            ),
        },
        {
            title: () => <TableTitle>Action</TableTitle>,
            dataIndex: 'action',
            width: 50,
            render: (_, record) => (
                <span className="form-check form-check-custom me-5">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="product"
                        data-kt-product-name="Basic"
                        checked={
                            programmesTravail.some((item) => item.programme_id === record.id)
                        }
                        onChange={() => {toggleCheckbox(record.id)}}
                    />
              </span>
            ),
        },
    ];

    const columnsSelectQuestions = [
        {
            title: () => <TableTitle>Question</TableTitle>,
            dataIndex: 'libelle',
            width: 450,
            render: (_, record) => (
                <div className="d-flex align-center">
                    <div className="me-2">
                        <Tag>
                            <span className='fw-boldest' style={{fontSize: '12px'}}>
                                {record.ref}
                            </span>
                        </Tag>
                    </div>
                    <span className='' style={{fontSize: '13px'}}>
                        {record.libelle}
                    </span>
                </div>
            ),
        },
        {
            title: () => <TableTitle>Assertions</TableTitle>,
            dataIndex: 'assertions',
            width: 100,
            render: (_, record) => (
                <Space>
                    {record.assertions?.map((assertion, index) => (
                        <Tag key={index}>
                            <span className='fw-bolder' >
                                {assertion}
                            </span>
                        </Tag>
                    ))}
                </Space>
            ),
        },
    ];

    const handleSearch = () => {
        setLoading(true);

        setTimeout(() => {
            const filteredClients = programmes.filter((ident) => {
                const {
                    question,
                    assertion,
                } = paramsRecherche;

                const lowercaseQuestion = question?.toLowerCase();
                const lowercaseAssertion = assertion?.toLowerCase();


                const matchQuestion =
                    !question ||
                    (ident.libelle
                            ?.toLowerCase()
                            ?.includes(lowercaseQuestion) ||
                        ident.ref
                            ?.toLowerCase()
                            ?.includes(lowercaseQuestion) );

                const matchAssertion =
                    !assertion ||
                    (ident.assertions ?? []).some(ass =>
                        ass?.toLowerCase()
                            ?.includes(lowercaseAssertion)
                    );


                return (
                    matchQuestion &&
                    matchAssertion
                );
            });

            setFilteredItems(filteredClients)

            setLoading(false);
        }, 1000);
    };

    const handleReset = () => {
        setLoading(true);
        setParamsRecherche({
            question: "",
            assertion: "",
        });
        setFilteredItems(programmes);
        setLoading(false);
    };

    return (
        <ModalAlert
            closeModal={handleVisibility}
            show={visible}
            title={<ModalTitle> Sélectionner les questions de travail (sources) </ModalTitle>}
            footer={[]}
            modalStyles={{ top: 10 }}
            width={1300}
        >
            <FormContainer>
                <SearchRow
                    handleSearch={handleSearch}
                    handleReset={handleReset}
                    loading={loading}
                >
                    <Col
                        xs={{ span: 24 }}
                        md={{ span: 16 }}
                        lg={{ span: 16 }}
                        xl={{ span: 16 }}
                    >
                        <FormLabel label="Question" />
                        <Input
                            style={{ width: "100%" }}
                            size="large"
                            placeholder="Rechercher par la référence, libellé"
                            value={paramsRecherche.question || null}
                            onChange={(e) => {
                                setParamsRecherche({
                                    ...paramsRecherche,
                                    question: e.target.value,
                                })
                            }}
                        />
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        md={{ span: 8 }}
                        lg={{ span: 8 }}
                        xl={{ span: 8 }}
                    >
                        <FormLabel label="Assertions" />
                        <Select
                            showSearch
                            placeholder="Rechercher par l'assertion..."
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            options={assertions.map((assertion) => ({
                                value: assertion.libelle,
                                label: assertion.libelle,
                            }))}
                            value={paramsRecherche.assertion || null}
                            onSelect={(value) =>
                                setParamsRecherche({
                                    ...paramsRecherche,
                                    assertion: value,
                                })
                            }
                            size="large"
                            style={{ width: "100%" }}
                        />
                    </Col>
                </SearchRow>
            </FormContainer>
            <Row gutter={[16, 16]}>
                <Col
                    xs={{ span: 24 }}
                    md={{ span: 16 }}
                    lg={{ span: 14 }}
                    xl={{ span: 14 }}
                >
                    <FormContainer>
                        <div className="table-responsive">
                            <Table
                                rowClassName={() =>
                                    `h-3px p-0 m-0 lh-0.5`
                                }
                                columns={columsProgrammes}
                                dataSource={filteredItems ?? []}
                                pagination={false}
                                scroll={{y: 400}}
                                loading={chargement || loading}
                                size={"small"}
                            />
                        </div>
                    </FormContainer>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    md={{ span: 8 }}
                    lg={{ span: 10 }}
                    xl={{ span: 10 }}
                >
                    <FormContainer>
                        <div className="table-responsive">
                            <Table
                                rowClassName={() =>
                                    `h-3px p-0 m-0 lh-0.5`
                                }
                                columns={columnsSelectQuestions}
                                dataSource={programmesTravail ?? []}
                                pagination={false}
                                scroll={{y: 400}}
                                loading={chargement || loading}
                                size={"small"}
                            />
                        </div>
                    </FormContainer>
                </Col>
            </Row>
            <div className="d-flex justify-content-center align-items-center mt-3">
                <div className="w-350px">
                    <Button
                        type="primary"
                        block
                        size="large"
                        // icon={<FontAwesomeIcon icon={fa} /> }
                        loading={loading}
                        disabled={loading}
                        onClick={handleValidate}
                    >
                        Valider
                    </Button>
                </div>
            </div>
        </ModalAlert>
    );
};

const PartiesLiee = ({
         mission,
         selectItems,
         setSelectItems,
         conclusion,
         setConclusion,
         setIsAddMemoire,
         isAddMemoire,
         chargement,
     }) => {
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleAdd = () => {
        setLoading(true);
        setTimeout(() => {
            const newElement = {
                libelle: '',
                reponse: '1',
                commentaire: '',
            };

            setSelectItems([...selectItems, newElement]);
            setLoading(false);
            notification.success({
                description: "Question ajouté avec succès !",
            });
        }, 1000);
    };

    const handleDeleteElement = (index) => {
        setLoading(true);
        setTimeout(() => {
            const updatedList = selectItems.filter((_, i) => i !== index);
            setSelectItems(updatedList);

            notification.success({
                description: "Question supprimé avec succès !",
            });
            setLoading(false)
        }, 1000)
    }

    const columns = [
        {
            title: () => <TableTitle>Nature</TableTitle>,
            dataIndex: 'libelle',
            sorter: true,
            width: 400,
            render: (_, record, index) => (
                <Input.TextArea
                    style={{fontSize: "14px"}}
                    size="large"
                    bordered={false}
                    placeholder="Saisisser la note..."
                    value={record.libelle}
                    maxLength={2000}
                    // showCount
                    autoSize={{
                        minRows: 1,
                        maxRows: 6,
                    }}
                    onChange={(e) =>{
                        const updatedList = selectItems.map((item, i) =>
                            i === index ? { ...item,  libelle: e.target.value } : item
                        );

                        setSelectItems(updatedList);
                    }}
                />
            ),
        },
        {
            title: () => <TableTitle>Réponse</TableTitle>,
            dataIndex: 'reponse',
            width: 100,
            render: (_, record, index) => (
                <select
                    style={{fontSize: '12px'}}
                    name='reponse'
                    className="form-select text-center"
                    onChange={(e) => {
                        const updatedList = selectItems.map((item, i) =>
                            i === index ? { ...item,  reponse: e.target.value === 'S/O' ? '1' : e.target.value === 'OUI' ? '2' : '3'} : item
                        );

                        setSelectItems(updatedList);
                    }}
                    value={record.reponse === '1' ? 'S/O': record.reponse === '2' ? 'OUI' : 'NON'  }
                >
                    {['S/O', 'OUI', 'NON'].map((opt, index) => (
                        <option key={index} value={opt}>
                            {opt}
                        </option>
                    ))}
                </select>
            ),
        },
        {
            title: () => <TableTitle>Commentaire</TableTitle>,
            dataIndex: 'commentaire',
            width: 400,
            render: (_, record, index) => (
                <>
                    <div className="">
                        <Input.TextArea
                            style={{fontSize: "14px"}}
                            size="large"
                            bordered={false}
                            placeholder="Saisisser le commentaire..."
                            value={record.commentaire}
                            maxLength={3000}
                            // showCount
                            autoSize={{
                                minRows: 1,
                                maxRows: 6,
                            }}
                            onChange={(e) =>{
                                const updatedList = selectItems.map((item, i) =>
                                    i === index ? { ...item,  commentaire: e.target.value } : item
                                );
                                setSelectItems(updatedList);
                            }}
                        />
                    </div>
                </>
            ),
        },
        {
            title: () => <TableTitle>Action</TableTitle>,
            dataIndex: 'action',
            width: 70,
            render: (_, record, index) => (
                <>
                    <Button
                        onClick={() => handleDeleteElement(index)}
                        title="Supprimer ?"
                        type="primary"
                        icon={<DeleteOutlined />}
                        danger
                    />
                </>
            )
        },
    ];

    const handleModalOpen = () => {
        setIsModalOpen(prevState => !prevState);
    }

    return (
        <>
            <div className="modal-body">
                <PageChildLabel label={"Parties liées"} />
                <div className="d-flex justify-content-end align-center my-2 me-5">
                    <div className="d-flex flex-wrap align-center">
                        <Space>
                            {(mission.isCloture !== 1 || mission.isClotureProvisoire !==1) && <Tooltip color={appTheme.colors.primary} title="Ajouter une nouvelle question">
                                <Button
                                    size={"middle"}
                                    style={{color: "white", backgroundColor: appTheme.colors.primary}}
                                    onClick={handleAdd}
                                    icon={<FontAwesomeIcon icon={faCartPlus}/>}
                                >
                                    Ajouter
                                </Button>
                            </Tooltip>}
                            {(mission.isCloture !== 1 || mission.isClotureProvisoire !==1) && <Tooltip color={appTheme.colors.primary} title="Ajouter une nouvelle question">
                                <Button
                                    size={"middle"}
                                    style={{color: "white", backgroundColor: appTheme.colors.primary}}
                                    onClick={handleModalOpen}
                                    icon={<FontAwesomeIcon icon={faCloudUpload}/>}
                                >
                                    Charger
                                </Button>
                            </Tooltip>}
                        </Space>
                    </div>
                </div>
                <div className="table-responsive pt-5 pb-10">
                    <Table
                        rowClassName={() =>
                            `h-3px p-0 m-0 lh-0.5`
                        }
                        columns={columns}
                        // rowKey={(record, index) => index}
                        dataSource={selectItems ?? []}
                        pagination={false}
                        // scroll={{y: 800}}
                        loading={chargement || loading}
                        // rowSelection
                        size={"small"}
                    />
                </div>
                <br/>
                <br/>
                <div className="d-flex flex-column mb-3 mx-2">
                    <FormLabel label="CONCLUSION" />
                    <Input.TextArea
                        style={{fontSize: "14px"}}
                        size="large"
                        placeholder="Saisisser la conclusion..."
                        value={conclusion}
                        maxLength={5000}
                        showCount
                        autoSize={{
                            minRows: 8,
                            maxRows: 10,
                        }}
                        onChange={(e) => setConclusion(e.target.value)}
                    />
                    <div className='mt-5'>
                        <div className="">
                            <Checkbox
                                onChange={() => setIsAddMemoire(!isAddMemoire)}
                                value={isAddMemoire}
                            >
                                Aide memoire
                            </Checkbox>
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <ModalProgrammes
                    handleVisibility={handleModalOpen}
                    visible={isModalOpen}
                    selectData={selectItems}
                    setSelectData={setSelectItems}
                    chargement={loading}
                />
            )}
        </>
    );
}

export {PartiesLiee}